import React from 'react';
import './AccessDenied.scss';
import { useTranslation } from 'react-i18next';

const { VITE_DASHBOARD_URL } = import.meta.env;

const AccessDenied = () => {
  const { t } = useTranslation();

  return (
    <div className="denied-container">
      <h1>
        4
        <div className="lock">
          <div className="top" />
          <div className="bottom" />
        </div>
        3
      </h1>
      <p>{t('access-denied')}</p>
      <p>{t('login-via-dashboard')}</p>
      <a href={VITE_DASHBOARD_URL}>{t('go-to-dashboard')}</a>
    </div>
  );
};

export default AccessDenied;
